<div class="tooltip-container" [ngClass]="{ 'show-tooltip': isHovering }">
	{{ content }}
</div>
